<template>
  <template v-if="this.$route.meta.layout === 'umwa'">
    <UmwaLayout />
  </template>
  <template v-if="this.$route.meta.layout === 'app'">
    <AppLayout />
  </template>
</template>
<script>
import AppLayout from '@/layouts/AppLayout.vue'
import UmwaLayout from '@/layouts/UmwaLayout.vue'

export default {
  name: 'DefaultLayout',
  components: {
    AppLayout,
    UmwaLayout,
  },
  data() {
    return {
      message: localStorage.getItem('message'),
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout')
      this.$router.push('/login')
    },
  },
}
</script>
